module.exports = __webpack_public_path__ + "img/zhongjiangjilu.4fe5699e.png";